import { useParams } from "react-router-dom";
import PurchaseHeader from "./purchaseComponents/PurchaseHeader";
import BreadcrumbPurchase from "./purchaseComponents/BreadcrumbPurchase";
import { FaChevronDown } from "react-icons/fa";
import CardProduct from "./purchaseComponents/CardProduct";
import EmptyList from "../../ui/EmptyList";
import ModalFilter from "./purchaseComponents/ModalFilter";
import { useEffect, useMemo, useRef, useState } from "react";
import ModalFilterPrincipal from "./purchaseComponents/ModalFilterPrincipal";
import ModalFilterCategory from "./purchaseComponents/ModalFilterCategory";
import ModalSortProduct from "./purchaseComponents/ModalSortProduct";
import { useQuery } from "@tanstack/react-query";
import {
  getBannerProductList,
  getPrincipalPbf,
} from "../../../services/purchaseApi";
import { CircularProgress, Skeleton } from "@mui/material";
import PurchasePagination from "./purchaseComponents/PurchasePagination";
import { useProductListQueryPbf } from "../../hooks/purchaseHook/useProductListQueryPbf";

const PurchaseProductListBanner = () => {
  const { bannerId } = useParams();
  const searchRef = useRef();

  const [reqBody, setReqBody] = useState({
    banner_uid: bannerId,
    offset: 1,
    limit: 50,
    order: "created_desc",
  });
  const [openFilter, setOpenFilter] = useState(false);
  const [openFilterPrincipal, setOpenFilterPrincipal] = useState(false);
  const [openFilterCategory, setOpenFilterCategory] = useState(false);
  const [openSort, setOpenSort] = useState(false);

  const { data: dataList, isFetching: isLoading } = useQuery({
    queryKey: ["data-promo-banner"],
    queryFn: () => getBannerProductList(reqBody),
    enabled: !!bannerId,
    refetchOnWindowFocus: false,
  });

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <PurchaseHeader searchRef={searchRef} />

      <div className="mt-[70px]">
        <div className="px-3 pt-2 mb-4">
          <BreadcrumbPurchase />
        </div>

        <div className="px-3 mb-4">
          <p className="text-[24px] font-semibold">Produk Promo</p>
        </div>

        <div className="w-full mb-4 block px-3">
          {dataList && !isLoading ? (
            <div>
              <div className="w-full bg-white rounded-md overflow-hidden mb-4">
                <img
                  src={dataList.image}
                  className="h-full w-full aspect-[2/1] object-cover rounded-md"
                />
              </div>

              <p className="font-bold text-[16px] mb-4">
                {dataList.banner_name}
              </p>

              <div className="bg-white rounded-md p-3">
                <p className="font-bold mb-2">Syarat & Ketentuan Promo</p>
                <p>{dataList.description}</p>
              </div>
            </div>
          ) : isLoading ? (
            <Skeleton variant="rounded" width={"100%"} height={200} />
          ) : null}
        </div>

        {dataList &&
        !isLoading &&
        dataList.products?.data &&
        dataList.total_data > 0 ? (
          <div className="px-3 mb-4 grid grid-cols-[repeat(auto-fill,minmax(160px,220px))] gap-3 items-stretch">
            {dataList.products.data.map((item, i) => {
              return (
                <div className="w-full relative h-full">
                  <CardProduct
                    product={item}
                    type={item.product_so_id ? 2 : 1}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="px-3 mb-4">
            {isLoading ? <CircularProgress size={20} /> : null}
          </div>
        )}
      </div>

      {dataList && !isLoading && dataList.total_data > 0 ? (
        <div className="px-4 mb-4">
          <PurchasePagination
            offset={reqBody.offset}
            limit={reqBody.limit}
            setOffset={(e) =>
              setReqBody((prevVal) => ({ ...prevVal, offset: e }))
            }
            setLimit={(e) => {
              setReqBody((prevVal) => ({ ...prevVal, limit: e }));
            }}
            total={dataList.total_data}
          />
        </div>
      ) : null}

      <ModalFilter
        open={openFilter}
        setOpen={setOpenFilter}
        reqBody={reqBody}
        setReqBody={setReqBody}
      />
      <ModalFilterPrincipal
        open={openFilterPrincipal}
        setOpen={setOpenFilterPrincipal}
        reqBody={reqBody}
        setReqBody={setReqBody}
      />
      <ModalFilterCategory
        open={openFilterCategory}
        setOpen={setOpenFilterCategory}
        reqBody={reqBody}
        setReqBody={setReqBody}
      />
      <ModalSortProduct
        open={openSort}
        setOpen={setOpenSort}
        reqBody={reqBody}
        setReqBody={setReqBody}
      />
    </div>
  );
};

export default PurchaseProductListBanner;
